import { addToast, closeToast } from "@heroui/react";

type ToastMessage = {
  title: string;
  description?: string;
};

type ToastPromiseOptions<T> = {
  loading: string;
  success:
    | string
    | ToastMessage
    | ((data: T) => string | ToastMessage | Promise<string | ToastMessage>);
  error:
    | string
    | ToastMessage
    | ((
        err: unknown,
      ) => string | ToastMessage | Promise<string | ToastMessage>);
};

export async function toastPromise<T>(
  promise: Promise<T>,
  opts: ToastPromiseOptions<T>,
): Promise<T> {
  const loadingToastId = addToast({ title: opts.loading, color: "default" });

  try {
    const result = await promise;
    const successMessage =
      typeof opts.success === "function"
        ? await opts.success(result)
        : opts.success;
    if (loadingToastId) {
      closeToast(loadingToastId);
    }
    addToast({
      title:
        typeof successMessage === "string"
          ? successMessage
          : successMessage.title,
      description:
        typeof successMessage === "string"
          ? undefined
          : successMessage.description,
      color: "success",
    });
    return result;
  } catch (err) {
    const errorMessage =
      typeof opts.error === "function" ? await opts.error(err) : opts.error;
    if (loadingToastId) {
      closeToast(loadingToastId);
    }
    addToast({
      title:
        typeof errorMessage === "string" ? errorMessage : errorMessage.title,
      description:
        typeof errorMessage === "string" ? undefined : errorMessage.description,
      color: "danger",
    });
    throw err;
  }
}
